import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { Toaster } from "@/components/ui/toaster";

// Lazy load below-the-fold components
const Services = lazy(() => import("@/components/Services"));
const CaseStudies = lazy(() => import("@/components/CaseStudies"));
const ContactForm = lazy(() => import("@/components/ContactForm"));
const Footer = lazy(() => import("@/components/Footer"));

// Loading placeholder for lazy components
function SectionLoader() {
  return <div className="min-h-[200px]" aria-hidden="true" />;
}

function Home() {
  return (
    <div className="w-full min-h-screen bg-white">
      <Header />
      <Hero />
      <Suspense fallback={<SectionLoader />}>
        <Services />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <CaseStudies />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <ContactForm />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Footer />
      </Suspense>
      <Toaster />
    </div>
  );
}

export default Home;